import React from "react";
import { MessageCircle } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

/** Compact "Share on WhatsApp" pill — funnels every visitor to forward a
 *  useful remedy/illness page to their family/friends in one tap. Uses the
 *  standard wa.me share URL (no phone number = universal share sheet on mobile,
 *  or WhatsApp Web on desktop). */
const ShareOnWhatsApp = ({ title, url, className = "" }) => {
  const { t } = useLanguage();
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const text = `${title ? `📖 ${title} — ` : ""}Islamic Cure & Care · ${shareUrl}`;
  const waHref = `https://wa.me/?text=${encodeURIComponent(text)}`;

  return (
    <a
      data-testid="share-on-whatsapp-btn"
      href={waHref}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe57] text-white font-medium text-xs sm:text-sm px-4 py-2 rounded-full transition shadow-sm ${className}`}
    >
      <MessageCircle className="w-4 h-4" /> {t("share_on_whatsapp")}
    </a>
  );
};

export default ShareOnWhatsApp;
